export default {
  /**
   * Export với tham số kèm dữ liệu
   */
  WithData: 0,
  /**
   * Export với tham số kèm payload do dữ liệu sẽ nhiều ko gửi qua kafka được
   */
  WithPayload: 1,
  /**
   * Báo cáo tổng hợp tài chính
   */
  SummaryFinanceReport: 2,
  /**
   * đẩy dữ liệu lên và đọc file cố định
   */
  WithFileData: 3,
  /**
   * Export với tham số kèm dữ liệu và xuất ra nhiều sheet
   */
  WithDataAndMultipleSheet: 4,
  /**
   * Export custom cho Kiểm tra công thức báo cáo
   */
  FormularReport: 5,
  /**
   * Export custom cho đối chiếu công thức báo cáo
   */
  CompareFormularReport: 6,
  /**
   * Export chi tiết phát sinh danh mục
   */
  IncurredDataExport: 7,

  /**
   * export dữ liệu danh mục không khớp nhau khi lấy số dư đầu năm từ dữ liệu cũ
   */
  OpeningDictionaryNotMatch: 8,

  /**
   * export dữ liệu danh mục không khớp nhau khi sao chép dữ liệu
   */
  CopyDataDictionaryNotMatch: 9,
  /**
   * export kết quả sao chép dữ liệu
   */
  CopyDataResult: 10,
};
